var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1212_5561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6185 10.2511L17.7382 12.4675V18.2303L13.858 20.4745L9.97776 18.2303V8.00693L16.0753 4.48831L13.858 3.18615L7.76048 6.70476V19.5048L13.858 23.0234L19.9555 19.5048V13.7697L27.716 9.28139V23.9931L13.858 32L0 23.9931V8.00693L2.7716 6.4V22.3861L13.858 28.7861L24.9444 22.3861V14.0745L22.7271 15.3489V21.1117L13.858 26.2372L4.98888 21.1117V5.12554L13.858 0L21.6185 4.48831L12.7494 9.58615V16.6234L13.858 17.2883L14.9666 16.6234V10.8883L18.8469 8.64416L21.6185 10.2511ZM26.6074 7.3697L23.8358 8.94892L21.0642 7.3697L23.8358 5.76277L26.6074 7.3697Z",
    fill: "#FF6C54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1212_5561"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateFull);
export default __webpack_public_path__ + "static/media/updateFull.86d93be25a1f5f8436d68bd7fa72da56.svg";
export { ForwardRef as ReactComponent };